import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

// Fetches reminders
export const fetchReminders = async () => {
  return (await wrapCall({
    method: callGet,
    uri: `/reminders`
  })) as APIReminder[]
}

// Fetches reminders with query
export const getReminderssWithQuery = async (query: string) => {
  return await wrapCall({
    method: callGet,
    uri: `/reminders${query}`,
    noData: true
  })
}

// Creates a new reminder
export const createReminder = async (data: ReminderPOST) => {
  return (await wrapCall({
    method: callPost,
    uri: `/reminders`,
    data
  })) as APIReminder
}

// Updates a reminder
export const updateReminder = async (id: string, data: ReminderPOST) => {
  return (await wrapCall({
    method: callPut,
    uri: `/reminders/${id}`,
    data
  })) as APIReminder
}

// Deletes a reminder
export const deleteReminder = async (id: string) => {
  return await wrapCall({
    method: callDelete,
    uri: `/reminders/${id}`
  })
}
